// modules
import { addModal } from 'weblite-web-modal-viewer'
// import { ViewStoryModalWrapper } from '$comp/modals/view-story-modal/view-story-modal'
import { ViewStory } from '$comp/_app/components/story/view-story'

const COMPONENT_ID = 'viewStoryModal'

export const showViewStoryModal = (props: Parameters<typeof ViewStory>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: ViewStory,
  },
}
